import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class InvoiceRegisterApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'invoice-register'
  }

}